// Web-only strings for the accessibility pass (PARITY P255): spoken names and live announcements,
// BOTH languages.
export const strings: { es: Record<string, string>; en: Record<string, string> } = {
  es: {
    'web.a11y.mentions': '%d menciones',
    'web.a11y.unread': 'sin leer',
    'web.a11y.withUnread': '%@, %d sin leer',
    'web.a11y.newMessage': 'Mensaje nuevo de %@: %@',
    'web.a11y.newMessages': '%d mensajes nuevos',
    'web.a11y.sendFailed': 'No se pudo enviar tu mensaje.',
    'web.a11y.skipToConversation': 'Ir a la conversación',
    'web.a11y.mainRegion': 'Conversación',
  },
  en: {
    'web.a11y.mentions': '%d mentions',
    'web.a11y.unread': 'unread',
    'web.a11y.withUnread': '%@, %d unread',
    'web.a11y.newMessage': 'New message from %@: %@',
    'web.a11y.newMessages': '%d new messages',
    'web.a11y.sendFailed': 'Your message could not be sent.',
    'web.a11y.skipToConversation': 'Skip to the conversation',
    'web.a11y.mainRegion': 'Conversation',
  },
};
